import React from "react";
import UserList from "../features/users/UserList";
import Page from "../Components/Page";
import useFetchData from "../hooks/useFetchData";
import { IUser } from "../features/users/types";
import { useTranslation } from "react-i18next";

export default function UsersPage() {
  const { data: users, isLoading } = useFetchData<IUser[]>("/users");
  const { t } = useTranslation();
  return (
    <Page title={t("Users")} isLoading={isLoading}>
      {users && <UserList users={users} />}
    </Page>
  );
}
